import { useEffect } from "react";
import { useNavigate } from "react-router";
import { Navbar, NavbarBrand, Button } from "reactstrap";
import styles from "./index.module.css";
import logoHb4RedColorida from "../../assets/images/hb4_reduzida_colorida.png";

function Termo() {
    const navigate = useNavigate();

    useEffect(() => {
        const perguntasId = localStorage.getItem("perguntasId");
        if (!perguntasId) {
            console.error("Erro: Nenhum ID de perguntas encontrado.");
        }
    }, []);

    const termo = `
        Declaro estar ciente e de acordo com os termos apresentados neste documento.
        Estou ciente de que todas as informações fornecidas serão utilizadas para fins de pesquisa e que 
        meus dados serão tratados de forma confidencial. Concordo em fornecer informações de maneira voluntária 
        e entendo que posso encerrar minha participação a qualquer momento, sem prejuízo algum.`;

        const handleAceitar = async (event) => {
            console.log("Botão clicado:", event.target.innerText);
            const perguntasId = localStorage.getItem("perguntasId");
        
            if (!perguntasId) {
                console.error("Erro: ID de perguntas não encontrado.");
                return;
            }
        
            try {
                localStorage.setItem(`termoAceito_${perguntasId}`, "true");
                navigate(`/perguntas/${perguntasId}`);
            } catch (error) {
                console.error("Erro ao registrar aceite:", error);
            }
        };
        

    const handleRecusar = (event) => {
        window.location.href = "https://www.google.com";
    };


    return (
        <div className={styles.mainDiv}>
            <Navbar className={styles.navbar} light expand="md">
                <NavbarBrand>
                    <div className={styles.divImage}>
                        <img src={logoHb4RedColorida} alt="Logo HB4" className={styles.image} />
                    </div>
                </NavbarBrand>
            </Navbar>

            <div className={styles.containerVerde}>
                <h1>Termo de Consentimento Livre e Esclarecido</h1>
            </div>

            <div className={styles.containerBranco}>
                <div className={styles.containerTexto}>
                    <p>{termo}</p>
                </div>
            </div>

            <div className={styles.containerCinza}>
                <Button className={styles.buttonEnviar} onClick={handleAceitar}>
                    Li e Aceito
                </Button>
                <Button className={styles.buttonRecusar} onClick={handleRecusar}>
                    Recusar
                </Button>
            </div>
        </div>
    );
}

export default Termo;
